"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectUserLeveragePreferences = exports.maxLeverageSelector = exports.currentLeverageSelector = void 0;
var _reselect = require("reselect");
var _marginSelectors = require("./marginSelectors");
var _instrumentPositionSelectors = require("../../selectors/instrumentPositionSelectors");
var _numberFormatter = require("../../../helpers/numberFormatter");
var maxLeverageSelector = exports.maxLeverageSelector = (0, _reselect.createSelector)(_marginSelectors.selectMarginInstrumentConfig, function (config) {
  return (0, _numberFormatter.formatNumberToLocale)(config !== null && config !== void 0 && config.InitialRequirement ? Math.round(1 / config.InitialRequirement + 1) : 0, 0);
});
var selectUserLeveragePreferences = exports.selectUserLeveragePreferences = function selectUserLeveragePreferences(state) {
  return state.margin.leverages.leverages;
};
var currentLeverageSelector = exports.currentLeverageSelector = (0, _reselect.createSelector)([selectUserLeveragePreferences, _instrumentPositionSelectors.selectedInstrumentIdSelector, maxLeverageSelector], function (leverages, instrumentId, maxLeverage) {
  return leverages[instrumentId] && leverages[instrumentId] <= maxLeverage ? leverages[instrumentId] : maxLeverage;
});